import Timeline from 'components/Timeline/Timeline'
import { DISPLAY_TYPE } from 'config/constants/ui'
import { TIMELINE_LAYERS_DEFAULT_HEIGHT } from 'constant'
import React, { FC } from 'react'
import SplitPane from 'react-split-pane'
import { SPLIT_RESIZER } from 'types/common'
import { getWindowHeight } from 'Util'

interface IProps {
  timelineDisplayType: typeof DISPLAY_TYPE[keyof typeof DISPLAY_TYPE]
  onSetResizing(arg1: boolean, arg2?: SPLIT_RESIZER): void
}

export const MainWrapper:FC<IProps> = ({ children, timelineDisplayType, onSetResizing }) => {
  const windowHeight = getWindowHeight()
  switch (timelineDisplayType) {
    case DISPLAY_TYPE.FULL_WIDTH: {
      return (
        <SplitPane
          split="horizontal"
          size="50%"
          defaultSize="50%"
          maxSize={windowHeight - TIMELINE_LAYERS_DEFAULT_HEIGHT}
          onDragStarted={() => onSetResizing(true, SPLIT_RESIZER.TIMELINE)}
          onDragFinished={() => onSetResizing(false)}
        >
          {children}
          <Timeline />
        </SplitPane>
      )
    }
    case DISPLAY_TYPE.HALF_WIDTH: {
      return <>{children}</>
    }
    default:
      return null
  }
}
